import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TopBar from '../builder/Interface/TopBar/TopBar';
import SettingsPanel from '../settings-panel/SettingsPanel.js';

import { useNavigate } from 'react-router-dom';

import { Form } from 'react-bootstrap';
import controls from './controls/FormControls';

import { WidgetsContext } from '../../GlobalContex';
import ShopSettings from '../widget/sources/Shop/Screens/ShopSettings';

import useShop from '../widget/sources/Shop/hooks/useShop';
import useEvents from '../widget/sources/Shop/hooks/useEvents';
import useProducts from '../widget/sources/Shop/hooks/useProducts';
import useNotifications from '../../hooks/useNotifications';

const Layouts = () => {
  const { t } = useTranslation();
  
  const { subscribe } = useEvents();
  const [page, setPage] = useState(1);
  const { setNotifications } = useNotifications();

  const { activeWidget, remoteWidget, setActiveWidgetSettingsParams, saveWidget, activeWidgetMeta } = useContext(WidgetsContext);
  
  const navigate = useNavigate();
  const settings = activeWidgetMeta.params;

  const isShop = activeWidget?.app?.name === 'shop';
  const shop = isShop && useShop(activeWidget);
  const products = isShop && useProducts(shop, { pagination: { page, perPage: 10 } });
  
  if (activeWidget.app.name === 'shop'){
    useEffect(() => {
      return subscribe((event, data, meta) => {
        switch (event) {
          case 'error':
            setNotifications((state) => {
              return [{ variant: 'danger', message: data.message }, ...state];
            });
            break;
          case 'shop.settings.updated':
            remoteWidget.set({ shop: data });
            break;
          case 'shop.products.outdated':
            products.refresh();
            remoteWidget.refreshProductsList();
            break;
          case 'shop.products.updated':
            if (meta.changes && 'status' in meta.changes) {
              remoteWidget.refreshProductsList();
            } else {
              remoteWidget.updateProduct(data);
            }
            break;
          case 'shop.products.empty':
            if (meta.currentPage > 1) {
              setPage(meta.totalPages);
            }
            break;
        }
      });
    }, [subscribe, products.refresh, remoteWidget]);
  }
  if (!settings) return null;
  const getActualWidgetProp = (item, newProp = activeWidget?.settings?.params?.[item.name]) =>
    typeof newProp === 'undefined' ? item.value : newProp;

  const isVisibleControl = (params, cond) => {
    if (!cond) return true;
    // maybe work not wrong
    const findProp = item => {
      let newProp = activeWidget?.settings?.params?.[item];
      return newProp !== undefined ? newProp : params.find(el => el.name === item)?.value;
    };

    if (Array.isArray(cond)) {
      let newcond = {};
      cond.forEach(condItem => {
        if (typeof condItem === 'string') newcond[condItem] = true;
        if (typeof condItem === 'object') Object.assign(newcond, condItem);
      });
      return isVisibleControl(params, newcond);
    }

    if (typeof cond === 'string') {
      return findProp(cond) === true;
    }

    if (typeof cond === 'object') {
      return Object.entries(cond).every(([key, value]) => {
        return findProp(key) === value;
      });
    }

    return true;
  };

  const handleClick = async () => {
    await saveWidget();
    navigate('/home');
  };

  const handleChange = (typeParams, e) => {
    let checkboxAction = { [typeParams]: e.target.checked };
    let defaultAction = { [typeParams]: e.target.value };

    let action = e.target.type === 'checkbox' ? checkboxAction : defaultAction;

    setActiveWidgetSettingsParams(action);
  };

  const createSettings = settings.map((item, i) => {
    if (!settings) return;
    if (!isVisibleControl(settings, item.conditions)) return;

    const Control = controls[item.type] ? controls[item.type] : controls['text'];
    return (
      <Control key={i} item={item} value={getActualWidgetProp(item)} onChange={handleChange} />
    );
  });

  return (
    <>
      <TopBar onClick={handleClick}>{t('Widget Layout')}</TopBar>
      <SettingsPanel>
        {activeWidget?.app?.name === 'shop' && <ShopSettings
          onChange={shop.updateSettings}
          settings={shop.settings}
          currencies={shop.currencies}
          >
        </ShopSettings>}
        <Form>{createSettings}</Form>
      </SettingsPanel>
    </>
  );
};

export default Layouts;
